import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BasicService } from 'src/app/shared/services/basic.service';

@Component({
  selector: 'app-migrate-to-wa-cloud-api',
  templateUrl: './migrate-to-wa-cloud-api.component.html',
  styleUrls: ['./migrate-to-wa-cloud-api.component.scss'],
})
export class MigrateToWaCloudApiComponent implements OnInit {
  @Input() migrateToDiferentWABA: boolean;
  @Output() migrateToWhatsappCloudApi: EventEmitter<void> = new EventEmitter();

  label: string = this.basicService.translate('accounts/edition/migrate-to-whatsapp-cloud-api');
  constructor(private basicService: BasicService) {}

  ngOnInit() {
    if (this.migrateToDiferentWABA) {
      this.label = this.basicService.translate('accounts/edition/migrate-to-another-waba');
    }
  }
}
